export function checkConfig(): boolean {
  const isConfigured = Boolean(CONFIG.MASSIVE_API_KEY);

  const warningElement = document.getElementById('config-warning');
  if (warningElement) {
    warningElement.classList.toggle('hidden', isConfigured);
  }

  const statusElement = document.getElementById('status');
  if (statusElement && isConfigured) {
    statusElement.textContent = 'Connected';
  }

  return isConfigured;
}
